/**
 * Códigos de erro de CONTATO que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const CONTACT_ERRORS = {
  /** 403 — só admin da empresa pode mesclar contatos (#4408). */
  MERGE_FORBIDDEN: "ERR_CONTACT_MERGE_FORBIDDEN",
  /** 400 — tentou mesclar o contato com ele mesmo. */
  MERGE_SAME: "ERR_CONTACT_MERGE_SAME",
  /** 400 — grupo só mescla com grupo, individual só com individual. */
  MERGE_TYPE_MISMATCH: "ERR_CONTACT_MERGE_TYPE_MISMATCH",
  /** 409 — já existe mesclagem pendente para o contato que seria absorvido. */
  MERGE_ALREADY_QUEUED: "ERR_CONTACT_MERGE_ALREADY_QUEUED",
} as const;

export type ContactErrorCode = (typeof CONTACT_ERRORS)[keyof typeof CONTACT_ERRORS];
